const BreakPoints = {
    xs: 320,
    sm: 600,
    md: 900,
    lg: 1240,
    xl: 1920,
};

export default BreakPoints;
